import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

export const useDeleteCondition = () => {
  const { authHeader } = useAuth();

  return useMutation((id: any) => {
    return axios.delete(`${env.verifyServiceUrl}individual/section_condition/${id}/`, {
      headers: {
        Authorization: authHeader,
      },
    });
  });
};
